import React, { useState,useMemo,useRef, useEffect } from 'react';
import BpmnModeler from 'bpmn-js/dist/bpmn-modeler.production.min.js';
import "./index.css"
import "bpmn-js/dist/assets/diagram-js.css"
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css"
import "./bpmn-js-property-panel.css"
//	<link rel="stylesheet" href="https://unpkg.com/@bpmn-io/properties-panel/dist/assets/properties-panel.css">
import BpmnModdle from 'bpmn-moddle';
import {
  BpmnPropertiesPanelModule,
  BpmnPropertiesProviderModule,
} from 'bpmn-js-properties-panel';
import CommandIntercept from './CommandIntercept'
//import {Publish, Retrieve, Revert} from './utils/Publish.js'
import propertiesProviderModule  from "./provider";
import {useDispatch,useSelector} from 'react-redux';
import {databaseViewApi,usePublishMutation,useRetrieveQuery,useDeleteDataMutation,useGetOrgInfoQuery} from './redux/databaseView'
import {ImportExportDialog} from "./ImportExportDialog";
import {setFormDataMerge} from './redux/appState';
import {AlertDialog} from './AlertDialog';
import {WaitingElement} from './AddUserDialog';
import {functionalAreas} from './SystemDefaults.js';

export const magicModdleDescriptor=
	{
	name:"Magic",
	prefix:"magic",
	uri:"http://magic",
	xml:{
		tagAlias:"lowerCase"
		},
	associations:[],
	types:[
		{
		name:"BewitchedStartEvent",
		extends:[
			"bpmn:BaseElement"
			],
		properties:[
			{
			name:"spell",
			isAttr:true,
			type:"String"
			},
			{
			name:"condition",
			isAttr:true,
			type:"String"
			},
			{
			name:"prefixProcess",
			isAttr:true,
			type:"String"
			},
			{
			name:"variableChanges",
			isAttr:true,
			type:"String"
			},
			{
			name:"processVariables",
			type:"ProcessVariables"
			}
			]
		},
		{
		name:"ProcessVariables",
		superClass:[
			"Element"
			],
		properties:[
			{
			name:"values",
			isMany:true,
			type:"ProcessVariable"
			}
			]
		},
		{
		name:"ProcessVariable",
		superClass:[
			"Element"
			],
		properties:[
			{
			name:"name",
			isAttr:true,
			type:"String"
			},
			{
			name:"value",
			isAttr:true,
			type:"String"
			}
			]
		}
		]
	};

async function createEmptyXML(viewerInstance)
	{
	const moddle = new BpmnModdle();

	const xmlStr =
	  '<?xml version="1.0" encoding="UTF-8"?>' +
	  '<bpmn2:definitions xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" ' +
						 'id="empty-definitions" ' +
						 'targetNamespace="http://bpmn.io/schema/bpmn">' +
	  '</bpmn2:definitions>';


	const {
		rootElement: definitions
		} = await moddle.fromXML(xmlStr);

	// update id attribute
	definitions.set('id', 'NEW ID');

	// add a root element
	const bpmnProcess = moddle.create('bpmn:Process', { id: 'MyProcess_1' });
	definitions.get('rootElements').push(bpmnProcess);

	// xmlStrUpdated contains new id and the added process
	const {
		xml: xmlStrUpdated
		} = await moddle.toXML(definitions);
	console.log(xmlStrUpdated);
	viewerInstance.importXML(xmlStrUpdated);
	return xmlStrUpdated;
	}
	



function getCollaborationInfo(bpmnModeler)
	{
//		const bpmnModeler=bpmnViewerRef.current;
	const definitions = bpmnModeler.getDefinitions();
	const collaboration = definitions.rootElements.find(el => el.$type === 'bpmn:Collaboration');
	console.log(collaboration);
	if (collaboration) 
		return {id:collaboration.id,prefix:collaboration.prefixProcess} 
	}


function onChanged(e)
	{
	console.log('Element properties changed:', e);
	}
	
function BPMNViewer() 
	{
	const containerRef = useRef(null);
	const [bpmnModeler,setBPMNModeler]=useState(null);
	const dispatch=useDispatch();
	const [Publish]=usePublishMutation();
	const [Delete]=useDeleteDataMutation();
	const [openIE,setOpenIE]=useState(false);
	const loadedVersion=useRef(0);
	const loadedDiagram=useRef(0);
	const loadedName=useRef("");
	
	const [alertText,setAlertText]=useState(null);
	const [alertButtons,setAlertButtons]=useState(null);
	
	const [waiting,setWaiting]=useState(false);
	const [actionText,setActionText]=useState("loading");
	const {isFetching,data:orgData}=useGetOrgInfoQuery();
	
	
	const allowedAreas=useMemo(()=>{
		var faList=null;
		if (!orgData?.data?.siteSettings)
			{	//testing this means if we are refetching, it will not go back to defaults -hopefully??
			faList=functionalAreas;
			}
		else
			{
			const siteSettings=JSON.parse(orgData.data.siteSettings);
			faList=siteSettings.functionalAreas;
			}
		var faObject={};
		faList.forEach((x)=>{
			faObject[x.area]=true;
			});
		return faObject;
		},[isFetching,orgData]);
	
	const modifiedData=useRef(null);//useSelector((state)=>state.appState.formDataMerge);
	
	console.log(modifiedData);
	useEffect(() => {
		if (!bpmnModeler)
			return;
		  const modeler = bpmnModeler;
		  // Works for both Viewer and Modeler
		  const eventBus = modeler.get('eventBus');

		  console.log('Registering listener');
		  eventBus.on('element.changed', onChanged);

		  return () => eventBus.off('element.changed', onChanged);
		}, []);
	async function save()
		{
		//console.log("save fv",viewerForm);
		
		if (bpmnModeler)
			{
			var schema=await bpmnModeler.saveXML();
			console.log(schema);
			localStorage.setItem("activeDiagram",JSON.stringify({schema:schema.xml,name:loadedName.current}));
			console.log(schema);
			}
		}

		
	async function getCurrentSchema()
		{
		if (bpmnModeler)
			{
			var schema=await bpmnModeler.saveXML(bpmnModeler);
			var collab=getCollaborationInfo(bpmnModeler);
			if (collab.id) 
				{
				schema.components=schema.xml;
				schema.id=collab.id;
				delete schema.xml;
				return {schema,id:schema.id,prefix:collab.prefix}
				} 
			console.log('No collaboration element found.');
			return {schema:null, id:-1}
			}
		return {schema:null,id:-2}
		}

	async function deleteCurrent(selection)
		{
		//if no selection then we need to get file name from current form, this looks like beginning of save
		var name=null;
		var schema=null;
		console.log(selection,"selection");
		if (!!selection)
			{
			const obj=await getCurrentSchema();
			schema=obj.schema;
			name=obj.id;
			}
		if (schema!=null)
			Delete({name,type:"diagram"});
		}
	
	async function createNew()
		{
		return open("$$createNew");
		}
		
	async function open(selection)
		{
		console.log(selection,"selection");
		var schema;
		if (typeof selection!=='string')
			{
			selection=selection.formid;
			}
		if (!bpmnModeler)
			return;
		if (!selection||selection=="")
			return;
		if (selection=="$$createNew")
			{
			const response = await fetch('diagram.bpmn');
			const xml = await response.text();
			console.log(xml);
			schema=xml;
			}
		else
			{
			schema=await dispatch(databaseViewApi.endpoints.retrieve.initiate({category:"diagram",name:selection}));
			if (schema.data.success)
				{
				schema=schema.data.data[0].components;
				console.log(schema);
				schema=JSON.parse(schema);
				var data={};
				schema=schema.components;
//				schema=decodeXML(schema);	//double strip because of adjacent replacement issue, where if replacing text occurs, it will not because			
											//used for the next one
				console.log(schema);
				}
			}
		await bpmnModeler.importXML(schema);
		var collabInfo=getCollaborationInfo(bpmnModeler);
		if (collabInfo.id)
			{
			loadedName.current=collabInfo.id;
			const root = bpmnModeler.get('canvas').getRootElement();
			loadedVersion.current=root.businessObject.$attrs['custom:version']?root.businessObject.$attrs['custom:version']:0;
			}
		}
	
	
	function validateLanes(root)
		{
		console.log(allowedAreas);
		const process = root.children?.[0];            // The BPMN Process element
		if (process)
			{
			const invalidLanes=[];
			console.log(process);
			const lanes = process.children;
			lanes.forEach(lane => 
				{
				if (lane.type=="bpmn:Lane")
					{
					if (lane.businessObject.name&&!allowedAreas[lane.businessObject.name]&&!lane.businessObject.name.startsWith("_"))
						{
						invalidLanes.push(lane.businessObject.name);
						console.log('Lane ID:', lane.id);
						console.log('Lane Name:', lane.businessObject.name);
	//					console.log('Flow nodes:', lane.flowNodeRef?.map(n => n.id));
						}
					}
			  });
			console.log(invalidLanes);
			if (invalidLanes.length)
				{
				var keys=Object.keys(allowedAreas);
				var activeText="The process has participants"+((invalidLanes>1)?"s":"")+" "+invalidLanes.join(", ")+" which are not in your list of functional areas ("+keys.join(", ")+")";
				setAlertText(activeText);
				setAlertButtons([{text:'Cancel Save',action:closeDialog}]);
				return false;
				}
			}
		else 
			{
			console.log('No lanes found in this process.');
			}
		return true;
		}
	
	async function actualPublish(result)
		{
		const root = bpmnModeler.get('canvas').getRootElement();
//		console.log(root);
		if (!validateLanes(root))
			return;
		var publishInfo=await Publish({category:"activeDiagram",name:"diagram",dataToSave:result.schema,prefix:result.prefix});
		if (publishInfo.data?.success)
			{
			var loadedID=publishInfo.data.data;
			root.businessObject.$attrs['custom:version'] = loadedID;
			loadedVersion.current=loadedID;
			loadedName.current=result.id;
			root.businessObject.$attrs['xmlns:custom'] = 'http://example.com/schema/custom';
			}
		}
	async function publish()
		{
		try 
			{
			//const modeling = bpmnModeler.get('modeling');
			console.log("here");
			const result=await getCurrentSchema();
				console.log("Name has been changed");
			console.log(result);
			if (result.schema!=null)
				{
				if (loadedName.current===result.id)
					actualPublish(result);
				else
					{
					console.log(result);
					modifiedData.current=result;
//					dispatch(setFormDataMerge(result));
					setAlertText("You have changed the name of this process, do you want to rename this version only (and create a new process) or rename the exisiting process");
					setAlertButtons([{text:'Create New',action:createNewProcess},{text:'Rename Process',action:RenameProcess},{text:'Cancel',action:closeDialog}]);
					}
				}
			save();
			}
		catch (e)
			{
			console.log(e);
			}
		//console.log("publish fv",viewerForm);
		}
	
	function createModeler()
		{
		const container = containerRef.current;
		var modeler = new BpmnModeler({ container: container,
												  propertiesPanel: {
																	parent: '#properties'
																	},
													additionalModules: [
																	BpmnPropertiesPanelModule,
																	BpmnPropertiesProviderModule,
																	propertiesProviderModule,
																	] ,
														moddleExtensions: {
																	magic: magicModdleDescriptor	
																	}});
		if (!modeler) 
			return null;
		setBPMNModeler(modeler);
		return modeler;
		}
	
	useEffect(() => {
		const container = containerRef.current;
		if (!container) 
			return;
		if (loadedDiagram.current)
			return;
		loadedDiagram.current=1;
		var modeler=createModeler();
		if (!modeler)
			return;
		async function loadDiagram(bpmnModeler) 
			{	//deliberately hide the state variable
			try {
				var schema;
				schema=localStorage.getItem("activeDiagram");
				if (!schema)
					{
					const response = await fetch('diagram.bpmn');
					const xml = await response.text();
					schema=xml;
					loadedName.current=null;
					}
				else
					{	
					//we need to remember the name it was originally loaded with so that we canvas
					//tell when it is updated
					console.log(schema);
					try 
						{
						schema=JSON.parse(schema);
						console.log(schema);
						loadedName.current=schema.name;	
						schema=schema.schema;
						}
					catch (e)
						{
						console.log("old style schema");
						loadedName.current=null;						
						}
					}
				await bpmnModeler.importXML(schema);
				var collabInfo=getCollaborationInfo(bpmnModeler);
				if (!!collabInfo&&collabInfo.id)
					{
					//we don't reload the name from this file;
					//loadedName.current=collabInfo.id;
					const root = bpmnModeler.get('canvas').getRootElement();
					loadedVersion.current=root.businessObject.$attrs['custom:version'];
					//console.log(loadedName.current,loadedVersion.current,collabInfo);
					}

				} 
			catch (error) 
				{
				console.error('Error loading BPMN diagram:', error);
				}
			}
		loadDiagram(modeler);
		
		return () => {
			if (bpmnModeler) 
				{
				bpmnModeler.destroy();
				loadedDiagram.current=0;
				setBPMNModeler(null);
				}
			};
		}, []);
	
//		if (modifiedData.modification!="process")
//			dispatch(setFormDataMerge(null));

	
	async function createNewProcess()
		{
		console.log("createNewProcess",modifiedData.current);
		var data={...modifiedData.current};
		console.log(data);
		await setAlertText(null);
		await actualPublish(data);	//just go on and publish it as always
//		dispatch(setFormDataMerge(null));
		modifiedData.current=null;
		}

	async function closeDialog()
		{
		console.log("closeDialog");
//		dispatch(setFormDataMerge(null));	
		modifiedData.current=null;
		setAlertText(null);
		}

	function zoomIn() 
		{
		const canvas = bpmnModeler.get('canvas');
		canvas.zoom(canvas.zoom() * 1.2);
		}

	function zoomOut() 
		{
		const canvas = bpmnModeler.get('canvas');
		canvas.zoom(canvas.zoom() / 1.2);
		}

	function zoomReset() 
		{
		bpmnModeler.get('canvas').zoom(1);
		}

	function zoomFit() 
		{
		bpmnModeler.get('canvas').zoom('fit-viewport');
		}
	async function RenameProcess()
		{
		console.log("Rename Process");
		var data={...modifiedData.current};
		await dispatch(databaseViewApi.endpoints.rename.initiate({type:"diagram", oldName:loadedName.current,newName:data.id}));
		await actualPublish(data);	//just go on and publish it as always
//		dispatch(setFormDataMerge(null));
		modifiedData.current=null;
		setAlertText(null);
		}

	async function loadNewProcessDiagram(xml)
		{
		setWaiting(true);
		setActionText("Importing XML");
		//bpmnModeler.clear(); // ✅ clears current elements, listeners, etc.
		bpmnModeler.destroy();
		var modeler=createModeler();
		if (!modeler)
			return;
		console.log(xml);
		await modeler.importXML(xml);
		modeler.get('canvas').zoom('fit-viewport');
		setTimeout(()=>setWaiting(false),500);
		}

//	console.log(modifiedData)
	return (
		<div
			className="modeler"
			style={{
				flex: 1,
				height: '100%',
				display: 'flex',
				flexDirection: 'row'
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					flex: 1,
					height: '100%',
					minWidth: 0,
					minHeight: 0
				}}
			>
				<CommandIntercept
					onPublish={publish}
					onDelete={deleteCurrent}
					onNew={createNew}
					onOpen={open}
					onSave={save}
					onDataXChange={() => setOpenIE(true)}
					getType={() => "diagram"}
				/>

				<AlertDialog
					open={alertText != null}
					actions={alertButtons}
					text={alertText}
				/>

				<ImportExportDialog
					title="Copy/Paste XML to this box"
					loadData={() => bpmnModeler.saveXML()}
					updateData={loadNewProcessDiagram}
					open={openIE}
					onClose={() => setOpenIE(false)}
				/>

				<WaitingElement
					actionText={actionText}
					waiting={waiting}
				>
					<div
						ref={containerRef}
						style={{
							flex: 1,
							minHeight: 0,
							position: 'relative'
						}}
					>
						<div className="bpmn-zoom-controls">
							<button onClick={zoomOut}>−</button>
							<button onClick={zoomReset}>1:1</button>
							<button onClick={zoomIn}>+</button>
							<button onClick={zoomFit}>Fit</button>
						</div>
					</div>
				</WaitingElement>
			</div>

			<div
				style={{
					width: '20%',
					minWidth: 250
				}}
				id="properties"
			/>
		</div>
	);
	}
	
export default BPMNViewer;